module.exports = __webpack_public_path__ + "static/media/A2.6a80da0e.jpg";